import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

export const isServerContext = (): boolean => {
  const platformId = inject(PLATFORM_ID);

  return isPlatformServer(platformId);
};
